export default __webpack_public_path__ + "static/media/visa.8b04f8d5.svg";